import type { ButtonHTMLAttributes } from 'react'
import { cn } from '@/lib/utils'
import styles from '@/styles/chase-light-button.module.css'

interface ChaseLightButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  innerClassName?: string
}

/** 边框流动追光按钮（空状态「立即创建项目」专用） */
export function ChaseLightButton({ className, innerClassName, children, ...props }: ChaseLightButtonProps) {
  return (
    <button type="button" className={cn(styles.wrapper, className)} {...props}>
      <span className={cn(styles.inner, innerClassName)}>{children}</span>
    </button>
  )
}
